import { motion } from "framer-motion";

export const Reveal = ({ children, className = "", delay = 0, as = "div" }) => {
    const Tag = motion[as] || motion.div;

    return (
        <Tag
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.75, delay: delay / 1000, ease: [0.22, 1, 0.36, 1] }}
            className={className}
        >
            {children}
        </Tag>
    );
};
